"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeFieldProps = exports.getInitialValues = exports.isAnyFormLinkVisible = exports.handleKeyDown = exports.mapUserForm = exports.mapUserFormValues = void 0;

var _form = require("@widergy/web-utils/lib/form");

var _lodash = _interopRequireDefault(require("lodash"));

var FIELD_TYPES = _interopRequireWildcard(require("../constants/fieldTypes"));

var _fieldsHelper = require("./fieldsHelper");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var mapUserFormValues = function mapUserFormValues(fields, values) {
  var newFields = (0, _fieldsHelper.removeAuxiliaryFields)(fields);

  var _userFormMapValues = (0, _fieldsHelper.userFormMapValues)(values, newFields),
      newValues = _userFormMapValues.newValues;

  return newValues;
};

exports.mapUserFormValues = mapUserFormValues;

var mapUserForm = function mapUserForm(fields, values) {
  var newFields = (0, _fieldsHelper.removeAuxiliaryFields)(fields);
  var mappedValues = (0, _fieldsHelper.userFormMapValues)(values, newFields);
  return mappedValues;
};

exports.mapUserForm = mapUserForm;

var handleKeyDown = function handleKeyDown(handleSubmit) {
  return function (event) {
    return (0, _form.submitListener)(event, handleSubmit);
  };
};

exports.handleKeyDown = handleKeyDown;

var isAnyFormLinkVisible = function isAnyFormLinkVisible(registeredFields, fields) {
  var fieldNames = Object.keys(registeredFields);

  var _loop = function _loop(i) {
    var field = fields.find(function (element) {
      return element.id.toString() === fieldNames[i].substring(2);
    });
    if (field.type === FIELD_TYPES.FIELD_FORM_LINK) return {
      v: true
    };
  };

  for (var i = 0; i < fieldNames.length; i += 1) {
    var _ret = _loop(i);

    if (typeof _ret === "object") return _ret.v;
  }

  return false;
};

exports.isAnyFormLinkVisible = isAnyFormLinkVisible;

var getInitialValues = function getInitialValues(fields) {
  var initialValues = {};
  fields.forEach(function (field) {
    if (field.default_value) initialValues["id".concat(field.id)] = field.default_value;
  });
  return initialValues;
};

exports.getInitialValues = getInitialValues;

var mergeFieldProps = function mergeFieldProps() {
  var originalFieldProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fieldPropsToAdd = arguments.length > 1 ? arguments[1] : undefined;

  var fieldProps = _lodash.default.clone(originalFieldProps, true);

  Object.values(FIELD_TYPES).forEach(function (key) {
    return fieldProps[key] = Object.assign(fieldProps[key] || {}, fieldPropsToAdd[key] || {});
  });
  return fieldProps;
};

exports.mergeFieldProps = mergeFieldProps;